export default {
  date: 'May 23, 2024',
  title: 'Site Updates: New Layout Sets Showcase and Improved Order Form',
  description: 'We are pleased to announce new updates on our website that will make the process of choosing and ordering layouts even more convenient and efficient for you!',
  id: 'new-order-form',
  jsx: () => (
    <div class='novelty__text'>
      <p>We are pleased to announce new updates on our website that will make the process of choosing and ordering layouts even more convenient and efficient for you!</p>
      <b>New Layout Sets Showcase</b>
      <p>We now have a showcase with layout sets available on our website. You can choose the set you are interested in and review its contents before purchasing. This allows you to clearly understand what is included in each package and make an informed decision.</p>
      <b>Convenient Order Form</b>
      <p>We have also updated the order form to make the process even simpler and more user-friendly. Depending on the chosen package, you now have the ability to:</p>
      <ul>
        <li>Specify the number of floors.</li>
        <li>Choose the style and view from the window.</li>
        <li>Add your logo.</li>
        <li>Leave a link to your website.</li>
        <li>Leave a comment to clarify details.</li>
        <li>Preview your order before payment.</li>
      </ul>
      <b>Why is this important?</b>
      <p>These updates are designed to make your experience with our website even more pleasant and effective. You can appreciate the convenience of the new features and quickly order the layout of your property. This will allow you to sell properties faster, saving your resources and time.</p>
      <p>We strive for continuous improvement of our service and hope that these changes will assist you in your work. Try the new features and see for yourself how convenient they are!</p>
      <p>Order your property layout right now and enjoy all the benefits of the updated website!</p>
    </div>
  ),
  thumb: 'news/18.webp',
};
